export default {
  genres: state => state.genres,
  years: state => genreId => state.years[genreId]
};
